const url = "/permissaoptamonitoras";
const id = "idenPermissaoPtaMonitora";

export const initFormAndamento = {
  idenAndamento: null,
  dataAndamento: "",
  descAndamento: "",
  ptaMonitora: null,
};

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criar(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}/${parm.ptaMonitora.idenPtaMonitora}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function excluir(idenAndamento) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${idenAndamento}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarPermissoesItem(idenPtaMonitora, page, size) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`${url}/listar/${idenPtaMonitora}?page=${page}&size=${size}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarPermissao(postBody) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarPermissaoUoPrograma(postBody) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}/uoprograma`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function removerPermissaoUsuario(postBody) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}
